(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('os-printing-choice')) {
    customElements.define(
      'os-printing-choice',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized) return;
          this.dataset.initialized = 'true';
          const choices = this.querySelectorAll('input[name="attributes[Printing required]"]');
          const dyeContainer = this.querySelector('[data-printing-dye]');
          const dyeSelect = this.querySelector('[data-printing-dye-select]');
          const notApplicable = this.dataset.notApplicable;

          const update = () => {
            const selected = this.querySelector('input[name="attributes[Printing required]"]:checked');
            const printingRequired = selected && selected.value !== notApplicable && selected === choices[0];
            dyeContainer.hidden = !printingRequired;
            dyeSelect.required = Boolean(printingRequired);
            if (printingRequired && dyeSelect.value === notApplicable) dyeSelect.value = '';
            if (!printingRequired && selected) dyeSelect.value = notApplicable;
          };

          choices.forEach((choice) => choice.addEventListener('change', update));
          update();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["os-product-buying-guide"] && !Shopify.designMode) return;
  try {
    function hydrateProductSizeCharts(root) {
    root.querySelectorAll('[data-os-product-buying]').forEach((guide) => {
      if (guide.hasAttribute('data-os-size-ready')) return;
      guide.setAttribute('data-os-size-ready', 'true');

      const title = guide.getAttribute('data-product-title') || '';
      const pattern = /(?:^|[^\d])(\d{2})\s*[-/xX]\s*(\d{2})\s*[-/xX]\s*(\d{3})(?=[^\d]|$)/g;
      let match;
      let dimensions;

      while ((match = pattern.exec(title)) !== null) {
        dimensions = {
          lens: Number(match[1]),
          bridge: Number(match[2]),
          temple: Number(match[3])
        };
      }

      if (!dimensions) return;
      if (dimensions.lens < 35 || dimensions.lens > 75) return;
      if (dimensions.bridge < 10 || dimensions.bridge > 35) return;
      if (dimensions.temple < 100 || dimensions.temple > 170) return;

      Object.entries(dimensions).forEach(([key, value]) => {
        const target = guide.querySelector(`[data-os-size-value="${key}"]`);
        if (target) target.textContent = String(value);
      });

      const chart = guide.querySelector('[data-os-frame-size]');
      if (chart) chart.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateProductSizeCharts(document));
  } else {
    hydrateProductSizeCharts(document);
  }

  document.addEventListener('shopify:section:load', (event) => hydrateProductSizeCharts(event.target));
  } catch(e) { console.error(e); }
})();

})();
